import { styled } from '@mui/system';

const Img = styled('img')``;

export default Img;
